import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import LoadingSpinners from '@/components/r3f/LoadingSpinners/LoadingSpinners';
import { useThree } from '@react-three/fiber';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { createCanvasR3fComponents, useGetActiveSceneScreenContentId } from '../../../../../utils';
import { getAnchorGroupPrositionDict } from '../../../r3f-components/utils/screen-relative';
const REFERENCE_CANVAS_HEIGHT = 700;
const AnchorGroups = () => {
    const { size } = useThree();
    const activeScreenContentId = useGetActiveSceneScreenContentId();
    const componentsById = useSelector((state) => state.contentReducer.contentDoc.componentsById);
    const screenRelativeContentScaleType = useSelector((state) => state.contentReducer.contentDoc.screenRelativeScaleType);
    const anchorGroupPositionDict = getAnchorGroupPrositionDict(size, screenRelativeContentScaleType);
    const hiddenEntities = Object.keys(componentsById).filter((entityId) => !!componentsById[entityId].isHidden);
    const activeScreenContent = componentsById[activeScreenContentId];
    const spinnerData = useSelector((state) => state.userReducer.spinnerData);
    const anchorGroups = activeScreenContent.children.map((id) => {
        const anchorGroup = componentsById[id];
        const anchorR3fComponents = createCanvasR3fComponents({
            ids: anchorGroup.children,
            hiddenEntityIds: hiddenEntities,
            componentsById,
        });
        const isAbsoluteUnitScale = screenRelativeContentScaleType === 'constant';
        const normalizationScale = isAbsoluteUnitScale ? REFERENCE_CANVAS_HEIGHT / size.height : 1;
        return (_jsxs("group", { scale: normalizationScale, name: anchorGroup.anchorPositionType, position: anchorGroupPositionDict[anchorGroup.anchorPositionType], children: [anchorR3fComponents, anchorGroup.anchorPositionType === 'center' && _jsx(LoadingSpinners, { isScreenRelativeSpinners: true, spinnerDataArray: Object.values(spinnerData) })] }, anchorGroup.anchorPositionType));
    });
    return _jsx(_Fragment, { children: anchorGroups });
};
export default memo(AnchorGroups);
